import { z } from "zod";
import { mediaListSchema } from "../common.js";
import { VT_OUI_NON } from "./utilities.js";

export const VT_FACADE_NATURES = [
  "parpaing",
  "maison_phoenix",
  "ite",
  "ossature_bois",
  "autre",
] as const;
export type VtFacadeNature = (typeof VT_FACADE_NATURES)[number];

export const VT_FACADE_NATURE_LABELS: Record<VtFacadeNature, string> = {
  parpaing: "Parpaing",
  maison_phoenix: "Maison Phoenix",
  ite: "ITE",
  ossature_bois: "Ossature bois",
  autre: "Autre",
};

export const vtExtensionSchema = z
  .object({
    isExtensionHouse: z.boolean().optional(),
    // Toiture
    photoRoofEdgeProfile: mediaListSchema.optional(),
    photoRoofEdgeFace: mediaListSchema.optional(),
    // Altimétrie
    altimetryFloorPhoto: mediaListSchema.optional(),
    altimetryFloorSchema: mediaListSchema.optional(),
    // Façade
    facadeSurveyPhoto: mediaListSchema.optional(),
    openingDimensionsPhoto: mediaListSchema.optional(),
    openingObstacles: z.boolean().optional(),
    openingObstaclesText: z.string().optional(),
    vmcPresent: z.boolean().optional(),
    waterproofDoor: z.boolean().optional(),
    facadeInsulated: z.boolean().optional(),
    facadeNature: z.enum(VT_FACADE_NATURES).optional(),
    facadeNatureOther: z.string().optional(),
    // Solin
    solinPresent: z.boolean().optional(),
    solinLength: z.number().optional(),
    solinAngleRequired: z.boolean().optional(),
    solinAngleOut: z.number().optional(),
    solinAngleIn: z.number().optional(),
    customCouvertine: z.boolean().optional(),
    customCouvertinePhoto: mediaListSchema.optional(),
    // VMC — obligatoire quand isExtensionHouse
    vmcSufficient: z.enum(VT_OUI_NON).optional(),
    vmcSufficientPhoto: mediaListSchema.optional(),
    extensionRemarks: z.string().optional(),
  })
  .partial();

export type VtExtension = z.infer<typeof vtExtensionSchema>;
